module.exports = __webpack_public_path__ + "static/media/MixTail.6093fb22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clients/MixTail.png
// module id = 367
// module chunks = 0